import type { VoidFunctionComponent } from 'react';

import { useCurrentProject } from '../../../../hooks/api/projects/useCurrentProject';
import { useCurrentRevision } from '../../../../hooks/api/revisions/useCurrentRevision';
import useScanRevision from '../../../../hooks/api/revisions/useScanRevision';
import TooltipButton from '../../../generic/Button/TooltipButton';
import { icons } from '../../../generic/Icon';
import { useCanUserEditProject } from '../../settingsv2/permissions';

export const PolicyScanButton: VoidFunctionComponent = () => {
  const project = useCurrentProject();
  const revision = useCurrentRevision();
  const revisionLocator = revision.data?.locator;
  const canEditProject = useCanUserEditProject(project.data?.locator ?? '');
  const { mutate, isPending } = useScanRevision();

  const handleClick = () => {
    if (!revisionLocator) {
      return;
    }
    mutate(revisionLocator);
  };

  return (
    <TooltipButton
      id="policy-scan-button"
      type="primary"
      size="medium"
      icon={icons.reload}
      iconHasSpin={isPending}
      isDisabled={!canEditProject || isPending || !revisionLocator}
      onClick={handleClick}
      showTooltip={!canEditProject}
      tooltip="You do not have permission to edit this project"
    >
      Run New Scan
    </TooltipButton>
  );
};
